import './FieldCheckbox.scss'

import cn from 'classnames'
import { forwardRef } from 'react'

export type IFieldCheckbox = {
  className?: string
  title?: string
  id: number | string
  value: (string | number)[]
  children: React.ReactNode
  onChange: (value: (string | number)[]) => void
  errors?: string[]
  // readonly?: boolean
}

export type Ref = HTMLInputElement

const FieldCheckbox = forwardRef<Ref, IFieldCheckbox>(
  (
    {
      className,
      children,
      onChange,
      id,
      value = [],
      // title = '',
      errors = [],
      //  readonly = false,
    },
    ref,
  ) => {
    const parsedErrors = (() => {
      if (errors === null || errors.length === 0) return null

      return errors.join(', ')
    })()

    const handleChange = () => {
      onChange(value.includes(id) ? value.filter((item) => item !== id) : [...value, id])
    }

    return (
      <div
        className={cn('field-checkbox', {
          [`${className}`]: !!className,
        })}
      >
        {/* {title && <div className="field-checkbox__title">{title}</div>} */}

        <div className="field-checkbox__body">
          <label className="field-checkbox__label">
            <input
              ref={ref}
              type="checkbox"
              checked={value.includes(id)}
              onChange={() => handleChange()}
              className="field-checkbox__input"
            />
            <span className="field-checkbox__name">{children}</span>
          </label>
        </div>

        {parsedErrors && <div className="field-checkbox__error">{parsedErrors}</div>}
      </div>
    )
  },
)

FieldCheckbox.displayName = 'FieldCheckbox'

export default FieldCheckbox
